<div class="modal privacy">
  <div class="modal__top">
    <span class="modal__title">{{ 'FOOTER.PRIVACY_POLICY' | i18nextEager | uppercase }}</span>
    <img
      (click)="closeModal()"
      src="/assets/icons/close_modal.svg"
      class="modal__click"
      alt="{{ 'COMMONS.CLOSE' | i18nextEager }}"
    />
  </div>
  <div class="modal__body">
    <p>
      {{ 'PRIVACY.P1.START' | i18nextEager }}
      <span (click)="openCookies()">{{ 'PRIVACY.P1.LINK' | i18nextEager }} </span>
      {{ 'PRIVACY.P1.END' | i18nextEager }}
    </p>
    <p>
      {{ 'PRIVACY.P2' | i18nextEager }}
    </p>
    <p>
      {{ 'PRIVACY.P3.START' | i18nextEager
      }}<a href="mailto:protecciondedatosenergia@acciona.com">{{ 'PRIVACY.P3.LINK' | i18nextEager }}</a
      >{{ 'PRIVACY.P3.END' | i18nextEager
      }}<a href="http://www.aepd.es" target="_blank">{{ 'PRIVACY.P3.LINK2' | i18nextEager }}</a
      >).
    </p>
  </div>
</div>
